<template>
    <datepicker
            class="bs-date btn-info"
            :class="cal"
            :minimum-view="minimumView || 'month'"
            :format="format || 'MMM yyyy'"
            :disabled-dates="disabled"
            @closed="$emit('closed')"
            v-model="inputValue"></datepicker>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'BSDate',
  props: ['minimumView', 'format', 'disabledDates', 'value', 'cal'],
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    disabled () {
      if (this.disabledDates) return this.disabledDates
      else {
        return { from: DateTime.local().minus({ months: 1 }).endOf('month').toJSDate() }
      }
    }
  }
}
</script>

<style lang="scss">
    .bs-date {

        input {
            font-size: 0.75rem;
            padding: 0.25rem 0.5rem;
            transition: all 0.15s ease;
            border-radius: 0.25rem;
            border-style: solid;
            cursor: pointer;
            text-align: center;
            text-transform: uppercase;
            font-weight: 700;
        }

        &.btn-info {
            font-weight: 700;

            &.vdp-datepicker {
                background: none;
            }
        }

        &.right {

            .vdp-datepicker__calendar {
                right: 0;
            }
        }
    }
</style>
